import { render } from "./FormExpress.vue?vue&type=template&id=74f4f3e2&scoped=true"
import script from "./FormExpress.vue?vue&type=script&lang=js"
export * from "./FormExpress.vue?vue&type=script&lang=js"

import "./FormExpress.vue?vue&type=style&index=0&id=74f4f3e2&scoped=true&lang=css"

import exportComponent from "/var/www/html/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-74f4f3e2"]])

export default __exports__